<template>
  <div class="rt-daterangepicker">
    <!-- =={{startDate}} -->
    <rt-date-picker
      :picker-options="pickerOptions"
      v-model="startDate"
      :disabled="disabled"
      class="rt-date-picker"
      @input="startDateChange"
    />
    <span>至</span>
    <!-- =={{endDate}} -->
    <rt-date-picker
      ref="datePicker"
      v-model="endDate"
      :disabled="endDisabled || disabled"
      @focus="endStartFocus"
      @input="endDateChange"
    />
  </div>
</template>

<script>
export default {
  name: 'RtDateRangePicker',
  props: {
    value: {
      type: [Array, String],
      default: () => [] || ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      startDate: this.value[0],
      endDate: this.value[1],
      dateRange: [],
      endDisabled: false,
      // Picker Options
      pickerOptions: {
        // 设置禁用状态，参数为当前日期，需求返回Boolean
        disabledDate(time) {
          // 1.只能选择今天以及今天之后的日期
          return time.getTime() < Date.now() - 8.64e7; // 如果没有后面的-8.64e7就是不可以选择今天的

          /*
            2.选择今天以及今天之前的日期
            return time.getTime() > Date.now() - 8.64e7;  //如果没有后面的-8.64e7就是不可以选择今天的
            */
        }
      }
    };
  },
  methods: {
    startDateChange() {
      this.dateRange.splice(0, 1, this.startDate);
      if (this.startDate) {
        this.endDisabled = false;
      }
      this.dateRange.splice(1, 1, this.endDate);
      this.$emit('input', this.dateRange);
    },
    endDateChange() {
      this.dateRange.splice(0, 1, this.startDate);
      let startTime = new Date(this.startDate);
      let endTime = new Date(this.endDate);
      if (startTime && endTime) {
        if (startTime > endTime) {
          rt.showErrorToast('结束日期不能小于开始日期！');
          this.$nextTick(() => {
            this.endDate = '';
          });
        }
      }
      this.dateRange.splice(1, 1, this.endDate);
      this.$emit('input', this.dateRange);
    },
    endStartFocus() {
      if (!this.startDate) {
        rt.showErrorToast('请先选择开始日期！');
        this.endDisabled = true;
      }
    }
  }
};
</script>

<style lang="less" scoped>
@deep: ~'>>>';
.rt-daterangepicker {
  display: flex;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid #e8ecfc;
  span {
    display: inline-block;
    padding: 6px 8px;
    color: #a9c2e8;
    font-size: 14px;
  }
  .rt-date-picker {
    flex: 1;
    @{deep} {
      .rt-input-shadow {
        display: none;
      }
    }
  }
  @{deep} {
    .el-input__prefix {
      right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// rtDateRangePicker.vue?057e5bfe